export default function formatMessageEventQueue (text) {
    return {
        text
    }
}
